/* Copyright (c) 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

export enum SidebarType {
  RESOURCE_GROUP = "resourceGroup",
  RESOURCE = "resource",
}

export type AddResourceSidebarState = {
  selectedResourceGroupIds?: string[] | [];
  selectedResourceIds?: string[] | [];
  activeSidebar?: SidebarType;
};
